"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const Button_1 = __importDefault(require("components/design-system/Button"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const ButtonAddInsights = ({ isEmptyRows, setIsAddNew }) => {
    return (react_1.default.createElement("div", { className: `bg-n-300 w-[144px] rounded-[4px] ${isEmptyRows ? 'h-[640px]' : 'h-[48px]'}` },
        react_1.default.createElement(Button_1.default, { variant: "tertiary", customClass: "w-full h-full", onClick: () => setIsAddNew(true) },
            react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-add", size: 24 }),
            react_1.default.createElement("p", { className: "typography-button" }, (0, HelperUtils_1.getObjectiveLocale)('Add Insight')))));
};
exports.default = ButtonAddInsights;
